import { AuditLiveMentionConfidence } from '@mi-front/core';
import { useAuditMention } from '../../../../../../../../audit/modules/station-audit/hooks/useAuditMention';
import { MentionConfidenceButtons } from './MentionConfidenceButtons';

type MentionConfidenceControlsProps = {
  stationId: string;
  id: string;
  className?: string;
};

/**
 * Allows accepting or rejecting the confidence assigned to a live mention.
 */
export function MentionConfidenceControls({
  stationId,
  id,
  className,
}: MentionConfidenceControlsProps) {
  const { data, isLoading, confidenceMutation } = useAuditMention(stationId, id);

  return (
    <MentionConfidenceButtons
      className={className}
      confidence={data?.confidence ?? AuditLiveMentionConfidence.AUTO}
      isLoading={isLoading}
      onConfidenceChange={(confidence) => confidenceMutation.mutate(confidence)}
    />
  );
}
